<ul class="instruction-steps">
	<li data-e2e-documents-upload-factoring-instructions-1>
		{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoText1' | translate }}
	</li>
	<li>
		<span data-e2e-documents-upload-factoring-instructions-2>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoText2' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-factoring-instructions-3>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoText3' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-factoring-instructions-4>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoText4' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-factoring-instructions-5>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoText5' | translate }}
		</span>
	</li>
</ul>

<ul class="data-information">
	<li>
		<strong>{{ 'DocumentRecordsColumnTypeCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-type>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoType' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnNumberCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-number>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoNumber' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnTotalCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-total>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoTotal' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnCurrencyCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-currency>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoCurrency' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnIssueDateCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-issued-date>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoIssueDate' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnDueDateCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-factoring-instructions-due-date>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoDueDate' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnBuyerCountryCodeCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-factoring-instructions-buyer-country-code>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoBuyerCountryCode' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnBuyerVatNumberCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-factoring-instructions-buyer-vat-number>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoBuyerVatNumber' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnSupplierCountryCodeCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-factoring-instructions-supplier-country-code>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoSupplierCountryCode' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnSupplierVatNumberCode' | translate: 'FactoringDocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-factoring-instructions-supplier-vat-number>
			{{ 'document-upload-factoring-instructions.DocumentTemplateInstructionsInfoSupplierVatNumber' | translate }}
		</span>
	</li>
</ul>
